import styled from "styled-components";

export const EditWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin: auto;
  max-width: 1710px;
  width: 100%;
`;
